import {NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule, provideHttpClient, withInterceptors} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {CredentialsService} from '../shared/services/credentials.service';
import {SwalService} from '~local/app/shared/services/SwalService';
import {AUTHENTICATION_TOKEN} from '~shared/ng/tokens/shared-tokens';
import {AuthenticationService} from '~local/app/shared/services/authentication.service';
import {KycService} from '~local/app/shared/services/KycService';
import {ContainerService} from '~shared/ng/services/container/container.service';
import {DialogService} from '~shared/ng/services/dialog/dialog.service';
import {AccountOpeningsService} from '~local/app/shared/services/AccountOpeningsService';
import {CountryLimitService} from '~local/app/shared/services/CountryLimitService';
import {UsersService} from '~local/app/shared/services/UsersService';
import {CardsService} from '~local/app/shared/services/CardsService';
import {TransactionsService} from '~local/app/shared/services/TransactionsService';
import {ExchangeService} from '~local/app/shared/services/ExchangeService';
import {CoinApiService} from '~local/app/shared/services/CoinApiService';
import {DashboardService} from '~local/app/shared/services/DashboardService';
import {SettingsService} from '~local/app/shared/services/SettingsService';
import {TriggersService} from '~local/app/shared/services/TriggersService';
import {NotificationTriggersService} from '~local/app/shared/services/NotificationTriggersService';
import {TicketService} from '~local/app/shared/services/TicketService';
import {CommissionService} from '~local/app/shared/services/CommissionService';
import {CostOfProductService} from '~local/app/shared/services/CostOfProductService';
import {ProfitMarginService} from '~local/app/shared/services/ProfitMarginService';
import {PackageService} from '~local/app/shared/services/PackageService';
import {LayoutService} from '~local/app/shared/services/LayoutService';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {CORRECT_DATE_FORMAT} from '~shared/ng/modules/material/material.module';
import {twoFactorAuthInterceptor} from '~shared/ng/interceptors/two-factor-auth.interceptor';
import {basicAuthInterceptor} from '~shared/ng/interceptors/basic-auth.interceptor';
import {otpAuthInterceptor} from '~shared/ng/interceptors/otp-auth.interceptor';
import {errorHandlerInterceptor} from '~local/app/shared/interceptors/error-handler.interceptor';
import {apiPrefixInterceptor} from '~local/app/shared/interceptors/api-prefix.interceptor';
import {authTokenIntercept} from '~local/app/shared/interceptors/auth-token.interceptor';
import {ErrorObservingService} from '~shared/ng/modules/validation/services/error-observing.service';
import {ValidationModule} from '~shared/ng/modules/validation/validation.module';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        TranslateModule,
        RouterModule,
        ValidationModule,
    ],
    providers: [
        ErrorObservingService,
        KycService,
        ContainerService,
        DialogService,
        AuthenticationService,
        SwalService,
        CredentialsService,
        provideHttpClient(
            withInterceptors([
                twoFactorAuthInterceptor,
                apiPrefixInterceptor,
                basicAuthInterceptor,
                authTokenIntercept,
                otpAuthInterceptor,
                errorHandlerInterceptor
            ]),
        ),
        {provide: AUTHENTICATION_TOKEN, useClass: AuthenticationService},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: CORRECT_DATE_FORMAT},

        // FIXME use all services only in their area of visibility; if some of them should be "provide in  root" - provide there
        // This is All shared module providers
        AccountOpeningsService,
        CountryLimitService,
        UsersService,
        CardsService,
        TransactionsService,
        ExchangeService,
        CoinApiService,
        SwalService,
        DashboardService,
        SettingsService,
        KycService,
        TriggersService,
        NotificationTriggersService,
        TicketService,
        CommissionService,
        CostOfProductService,
        ProfitMarginService,
        PackageService,
        LayoutService,
    ]
})
export class CoreModule {

    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        // Import guard
        if (parentModule) {
            throw new Error(`${parentModule} has already been loaded. Import Core module in the AppModule only.`);
        }
    }

}
